import ApiService from "./api.service";
export default class BookingService extends ApiService {
    static base_url = `${super.base_url}/bookings`;

    static async cancel(bookingId, axiosInstance, config = {}) {
        const response = await axiosInstance.post(`${this.base_url}/${bookingId}/cancel`, null, config);
        return response.data;
    }

    static async cancelDelete(bookingId, axiosInstance, config = {}) {
        const response = await axiosInstance.post(`${this.base_url}/${bookingId}/cancel-delete`, null, config);
        return response.data;
    }

    static async getAdminCancelPreview(bookingId, axiosInstance, config = {}) {
        const response = await axiosInstance.get(`${this.base_url}/${bookingId}/admin-cancel/preview`, {
            ...config,
            skipGlobalLoader: true,
            skipSuccessNotification: true,
        });
        return response.data;
    }

    static async adminCancel(bookingId, data, axiosInstance, config = {}) {
        const response = await axiosInstance.post(`${this.base_url}/${bookingId}/admin-cancel`, data, config);
        return response.data;
    }

    static async resendPaymentLink(bookingId, axiosInstance) {
        const response = await axiosInstance.post(`${this.base_url}/${bookingId}/resend-payment-link`, {});
        return response.data;
    }

    static async editQuote(bookingId, data, axiosInstance) {
        const response = await axiosInstance.post(`${this.base_url}/${bookingId}/edit-quote`, data);
        return response.data;
    }

    static async payDifference(data, axiosInstance) {
        const response = await axiosInstance.post(
            `${this.base_url}/${data.booking_id}/pay-difference`,
            {
                new_total: data.new_total,
                old_total: data.old_total,
                checkAvailibility: data.checkAvailibility || false,
                duration: data.duration || null,
                success_update: data.success_update || [],
            }
        );
        return response.data;
    }

    static async downloadReceipt(bookingId, axiosInstance) {
        const response = await axiosInstance.get(`${this.base_url}/${bookingId}/receipt`, {
            responseType: 'blob',
        });
        return response.data;
    }

    static async refundDifference(data, bookingId, axiosInstance) {
        const response = await axiosInstance.post(
            `${this.base_url}/${bookingId}/refund-difference`,
            {
                old_total: data.old_total,
                new_total: data.new_total,
            }
        );
        return response.data;
    }

    static async exportHotelClientBookings(hotel, params, axiosInstance) {
        const queryString = this.buildParams(params);
        const response = await axiosInstance.get(`${this.base_url}/hotels/${hotel}/export?${queryString}`);
        return response.data;
    }

    static async export(params, axiosInstance) {
        const queryString = this.buildParams(params);
        const response = await axiosInstance.get(`${this.base_url}/export?${queryString}`);
        return response.data;
    }

    static async heatmap(params, axiosInstance) {
        const queryString = this.buildParams(params);
        const response = await axiosInstance.get(`${this.base_url}/heatmap?${queryString}`);
        return response.data;
    }

    static async treatmentStats(params, axiosInstance) {
        const queryString = this.buildParams(params);
        const response = await axiosInstance.get(`${this.base_url}/treatment-stats?${queryString}`);
        return response.data;
    }

}
